import React, { Fragment } from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import Str from "shared/components/Str";

import BinaryQuestion from "apps/questions/containers/BinaryQuestion";
import ProfileQuestionLink from "apps/questions/containers/ProfileQuestionLink";

const BinaryQuestionsWrapper = (props) => {
	const { question } = props;

	return (
		<Fragment>
			{question && question.qtext && question.is_binary &&
				<BinaryQuestion question={question} />
			}

			{question && question.question && !question.is_binary &&
				<ProfileQuestionLink question={question} />
			}

			{isEmpty(question) &&
				<div className="binary-question-empty">
					<Str className="binary-question-empty-text">
						This doesn’t happen very often. You’ve answered all of the questions!
					</Str>
					<a className="binary-question-empty-link" href="/match">
						<Str>Why not go find a match?</Str>
					</a>
				</div>
			}
		</Fragment>
	);
};

BinaryQuestionsWrapper.propTypes = {
	question: PropTypes.object,
};

export default BinaryQuestionsWrapper;



// WEBPACK FOOTER //
// ./src/apps/questions/components/BinaryQuestionsWrapper.jsx